import { render, staticRenderFns } from "./ReminderInfo.vue?vue&type=template&id=501e03b1&"
import script from "./ReminderInfo.vue?vue&type=script&lang=js&"
export * from "./ReminderInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports